import { Spin, Tabs } from "antd";
import { useEffect, useState } from "react";
import axios from "axios";

import TimeSetting from "./TimeSetting";
import CompensationSetting from "./CompensationSetting";

const backend = process.env.REACT_APP_BACKEND;

function GeneralSetting() {
  const [timeSetting, setTimeSetting] = useState({});
  const timeHandler = (newTime) => {
    setTimeSetting(newTime);
  };

  useEffect(() => {
    axios
      .get(`${backend}/general_setting`)
      .then((data) => {
        setTimeSetting(data.data.data[0]);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const items = [
    {
      label: "시각 설정",
      key: "item-1",
      children: (
        <Spin spinning={Object.keys(timeSetting).length === 0 ? true : false}>
          <TimeSetting timeSetting={timeSetting} timeHandler={timeHandler} />
        </Spin>
      ),
    }, // remember to pass the key prop
    {
      label: "보상 설정",
      key: "item-2",
      children: (
        <Spin spinning={Object.keys(timeSetting).length === 0 ? true : false}>
          <CompensationSetting
            timeSetting={timeSetting}
            timeHandler={timeHandler}
          />
        </Spin>
      ),
    },
    {
      label: "기타",
      key: "item-3",
      children: <div>"향후 추가될 수 있는 설정 메뉴"</div>,
    },
  ];

  return (
    <div style={{ width: "100%", height:"100%" }}>
      <Tabs
        defaultActiveKey="item-1"
        type="card"
        size="middle"
        items={items}
        style={{ width: "100%", height:"100%" }}
      />
    </div>
  );
}

export default GeneralSetting;
